export const DEFAULT_ZONE = "Zone";
export const DEFAULT_LOCAL = "Local";
export const DEFAULT_FLOOR = "Stairs";
export const DEFAULT_ICON_SHOP = "Shop";
export const DEFAULT_ICON_SITE = "Default Site";
export const DEFAULT_ICON_BUILD = "Default Build";
export const DEFAULT_ICON_CLIENT = "Default Client";
export const DEFAULT_ICON_ENTITY = "Default Entity";